<div class="container">
    <h1 class="mb-4"><i class="far fa-cog text-primary"></i> Settings</h1>
    <div class="card round-corners heavy-shadow p-3 text-center">
        <div class="card no-shadow rounded border">
            <table class="table table-striped table-hover align-middle m-0 data-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Value</th>
                        <th class="text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of settingList" [ngSwitch]="s.settingType">
                        <td><span class="text-500">{{s.settingName}}</span></td>
                        <td *ngSwitchCase="pdxSystemSettingType.WYSIWYG" [innerHTML]="s.displayValue"></td>
                        <td *ngSwitchDefault>{{s.displayValue}}</td>
                        <td class="text-right">
                            <div class="" ngbDropdown>
                                <button class="btn btn-lg btn-white btn-shadow no-caret action-btn" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                                    <i class="far fa-ellipsis-v"></i>
                                </button>
                                <ul ngbDropdownMenu class="dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                    <li><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="editSettings(s)"><i class="far fa-pencil fa-fw"></i> Edit</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>